// extracted by mini-css-extract-plugin
export default {"root":"MultipleModalAdditionalContent_root__tpY2m","placeHolderShimmer":"MultipleModalAdditionalContent_placeHolderShimmer__f4L7d"};